module.exports = __webpack_public_path__ + "static/media/diagnoses.8caea26b.svg";